import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Backdrop, Footer, LogoLoader, showToast } from "../../../components";
import InvoiceDetails from "../Invoices/Invoices/InvoiceDetails";
import axiosRequest from "../../../redux/slices/universal/axiosService";
import Logo from "../../../assets/images/Logo.svg";
import { ENDPOINTS } from "../../../redux/apiConfig";
import { successGetCurrentInvoiceStart } from "../../../redux/slices/invoices/invoicesSlice";

const PublicInvoiceView = () => {
  const { orgId, invoiceId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const orgRes = await axiosRequest({
          method: "GET",
          url: `${ENDPOINTS.PUBLIC.GET_ORG_BASE_URL}/${orgId}/base-url`,
        });
        const { baseUrls } = orgRes.data?.data;
        let workforceUrl = baseUrls?.workforce;
        if (!workforceUrl) {
          showToast("Organization workforce URL not found", "error", 5000);
          return;
        }
        workforceUrl = workforceUrl.replace(/\/$/, "");
        const res = await axiosRequest({
          method: "GET",
          url: `${workforceUrl}/view/invoice/${invoiceId}`,
        });
        if (res.data?.data) {
          dispatch(successGetCurrentInvoiceStart({ ...res.data.data }));
        } else {
          showToast("Invoice not found", "error", 5000);
        }
      } catch (error) {
        console.error("Error fetching invoice:", error);
        showToast("Error fetching invoice", "error", 5000);
      } finally {
        setLoading(false);
      }
    };
    if (orgId && invoiceId) {
      fetchInvoice();
    }
  }, [orgId, invoiceId]);
  return (
    <div className="min-h-screen flex flex-col">
      {!loading && (
        <>
          <div className="flex-1 pb-10 mx-2">
            <InvoiceDetails
              removeButtonForPreview={true}
              isPublicView={true}
              companyLogo={Logo}
            />
          </div>
          <Footer />
        </>
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};
export default PublicInvoiceView;
